export const parseToNumberOrNull = (value: string): number | null => {
  if (
    value === 'null'
      || value === 'undefined'
      || value === ''
  ) return null

  const valueParsed = Number(value)
  if (Number.isNaN(valueParsed)) return null

  return valueParsed
}
